module.exports = __webpack_public_path__ + "img/skeleton_king.be466edd.png";